<template>
  <a class="button-link" :href="href" target="_blank">
    <span class="text"><slot /></span>
  </a>
</template>

<script>
export default {
  name: 'ButtonLink',
  props: {
    href: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped lang="scss">
.button-link {
  height: 48px;
  min-width: 210px;
  max-width: 300px;

  display: flex;
  flex-direction: column;
  justify-content: center;

  border: 1px solid #00cc9f;
  border-radius: 4px;

  color: #fff;
  font-size: 16px;
  line-height: 22px;

  background-color: $c-green-base;
}

.text {
  display: inline-block;
  padding: 0 8px;

  text-align: center;
}
</style>
